import { render, staticRenderFns } from "./instructionaldesign.vue?vue&type=template&id=1145df5f&scoped=true&"
import script from "./instructionaldesign.vue?vue&type=script&lang=js&"
export * from "./instructionaldesign.vue?vue&type=script&lang=js&"
import style0 from "./instructionaldesign.vue?vue&type=style&index=0&id=1145df5f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145df5f",
  null
  
)

export default component.exports